export enum NewsletterWelcomeSystemStepEnum {
  SELECT_TYPE = 'SELECT_TYPE',
  CONNECT_TO_1C = 'CONNECT_TO_1C',
  CREATE_COMPANY = 'CREATE_COMPANY',
  CREATE_CONTACTS = 'CREATE_CONTACTS',
  EXCEL_TEMPLATE = 'EXCEL_TEMPLATE',
  NEWSLETTER_TEXT = 'NEWSLETTER_TEXT',
  NEWSLETTER_CHANNEL = 'NEWSLETTER_CHANNEL',
  NEWSLETTER_PLANNING = 'NEWSLETTER_PLANNING'
}
